import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem('e-central:lang');
      if (stored === 'fr' || stored === 'en') return stored;
    }
    return 'fr';
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('e-central:lang', lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang((l) => (l === 'fr' ? 'en' : 'fr'));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
